/*
  Lista zyczen - magazyn danych w przegladarce.

  Lista jest nasza, bez zewnetrznej aplikacji, a jej trwalosc konczy sie na
  przegladarce danej osoby. Shopify nie pozwala motywowi zapisac niczego przy
  koncie klienta, wiec lista nie przenosi sie miedzy urzadzeniami.

  Ten plik jest jedynym zrodlem prawdy o zawartosci listy. Wszystko inne
  (serduszka na kartach, licznik w naglowku, podstrona listy) tylko czyta stad
  dane i nasluchuje zdarzenia `wishlist:change`.

  Ksztalt zapisu w pamieci przegladarki:
    { v: 1, items: [ { p, v, h, t } ] }
  gdzie p = identyfikator produktu, v = identyfikator wariantu, h = uchwyt
  produktu (potrzebny do pobrania karty), t = znacznik czasu dodania.

  TOZSAMOSC POZYCJI TO WARIANT. W tym sklepie warianty to rozmiary plyty, wiec
  polubienie plyty 280x122 nie ma zapalac serduszka przy 244x122 tego samego
  wzoru. Identyfikator produktu zapisujemy tylko pomocniczo.
*/

(() => {
  if (window.wishlist) return;

  const KEY = 'dizz_wishlist';
  const VERSION = 1;

  const emptyState = () => ({ v: VERSION, items: [] });

  /*
    Odczyt jest obronny: pamiec przegladarki bywa niedostepna (tryb prywatny,
    zablokowane dane witryny), a zapis mogl zostac recznie zepsuty. W obu
    przypadkach wracamy do pustej listy, zamiast wywracac strone.
  */
  const read = () => {
    try {
      const raw = window.localStorage.getItem(KEY);
      if (!raw) return emptyState();
      const parsed = JSON.parse(raw);
      if (!parsed || !Array.isArray(parsed.items)) return emptyState();
      return {
        v: VERSION,
        items: parsed.items
          .filter((item) => item && item.v)
          .map((item) => ({
            p: String(item.p || ''),
            v: String(item.v),
            h: String(item.h || ''),
            t: Number(item.t) || 0,
          })),
      };
    } catch {
      return emptyState();
    }
  };

  let state = read();

  const write = () => {
    try {
      window.localStorage.setItem(KEY, JSON.stringify(state));
    } catch {
      // Brak miejsca albo zablokowane dane witryny: lista dziala do konca sesji.
    }
  };

  const announce = (detail = {}) => {
    document.dispatchEvent(
      new CustomEvent('wishlist:change', { detail: { ...detail, count: api.count() } })
    );
  };

  const api = {
    // Najnowsze dodania na poczatku - klient szuka na liscie tego, co wlasnie polubil.
    items: () => [...state.items].sort((a, b) => b.t - a.t),

    count: () => state.items.length,

    has: (variantId) => {
      if (!variantId) return false;
      const key = String(variantId);
      return state.items.some((item) => item.v === key);
    },

    add: ({ variantId, productId, handle } = {}) => {
      if (!variantId) return false;
      const key = String(variantId);
      if (state.items.some((item) => item.v === key)) return false;
      state.items.push({
        p: String(productId || ''),
        v: key,
        h: String(handle || ''),
        t: Date.now(),
      });
      write();
      announce({ action: 'add', variantId: key });
      return true;
    },

    remove: (variantId) => {
      if (!variantId) return false;
      const key = String(variantId);
      const before = state.items.length;
      state.items = state.items.filter((item) => item.v !== key);
      if (state.items.length === before) return false;
      write();
      announce({ action: 'remove', variantId: key });
      return true;
    },

    toggle: (item) => {
      if (!item || !item.variantId) return false;
      return api.has(item.variantId) ? !api.remove(item.variantId) : api.add(item);
    },

    clear: () => {
      if (state.items.length === 0) return false;
      state.items = [];
      write();
      announce({ action: 'clear' });
      return true;
    },
  };

  window.wishlist = api;

  /*
    Druga karta tej samej przegladarki zmienila liste - przeladowujemy stan i
    oglaszamy to u siebie, zeby serduszka i licznik nie klamaly.
  */
  window.addEventListener('storage', (event) => {
    if (event.key !== KEY) return;
    state = read();
    announce({ action: 'external' });
  });

  // Pierwsze ogloszenie po wczytaniu: licznik i serduszka ustawiaja sie same.
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => announce({ action: 'init' }));
  } else {
    announce({ action: 'init' });
  }
})();
